"use client";

import Link from "next/link";
import React from "react";

interface FullHeightImageBulletsProps {
  imageSrc: string;
  heading: string;
  subheading: string;
  text?: string; // Optional text
  bullets?: string[]; // Array of bullet points
  buttonText: string;
  buttonLink: string;
  imgClassName?: string;
  imagePosition?: "left" | "right";
}

const FullHeightImageBullets: React.FC<FullHeightImageBulletsProps> = ({
  imageSrc,
  heading,
  subheading,
  text,
  bullets,
  buttonText,
  buttonLink,
  imgClassName = "",
  imagePosition = "left",
}) => {
  return (
    <div
      className={`flex flex-col p-4 mb-10 md:flex-row rounded-lg overflow-hidden ${
        imagePosition === "right" ? "md:flex-row-reverse" : ""
      }`}
    >
      {/* Image Section */}
      <div className="w-full md:w-1/2">
        <img
          src={imageSrc}
          alt={heading}
          className={`w-full h-auto ${imgClassName}`}
        />
      </div>

      {/* Content Section */}
      <div className="w-full md:w-1/2 p-6 bg-[var(--burgundy)]">
        <h1 className="text-2xl font-bold text-[var(--text-on-dark)]">{heading}</h1>
        <h2 className="text-lg text-[var(--text-on-dark-muted)]">{subheading}</h2>

        {/* Render Text */}
        {text && <p className="text-[var(--text-on-dark-muted)] mt-4">{text}</p>}

        {/* Render Bullets */}
        {bullets && bullets.length > 0 && (
          <ul className="list-disc list-inside text-[var(--text-on-dark-muted)] mt-4 mb-10">
            {bullets.map((bullet, index) => (
              <li key={index}>{bullet}</li>
            ))}
          </ul>
        )}

        {/* Button */}
        <Link
          href={buttonLink}
          className="mt-6 inline-block px-6 py-3 bg-[var(--text-on-dark)] text-[var(--burgundy)] font-semibold rounded-xl transition hover:opacity-90"
        >
          {buttonText}
        </Link>
      </div>
    </div>
  );
};

export default FullHeightImageBullets;